export default "__VITE_ASSET__X9yawdZ2__"